import JassEnum from './enum';

/**
 * type mapdensity
 */
export default class JassMapDensity extends JassEnum {}
